export const menageInquiriesSummaryKey = {
  ISSUED: 'issued',
  IN_PROGRESS: 'inProgress',
  ANSWERED: 'answered',
} as const;
